export default __webpack_public_path__ + "static/media/ic-back.6b84ffd9.svg";